import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown, renderSearchDropDown } from '../../common/form/FieldHelper';

class ClassificationDropdown extends Component {

  render() {

    const {
      name,
      form,
      searchFn,
      onPostChange,
      multiple,
      alternate_class,
      excluded_classifications,
      included_classifications,
      preload = true,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType='classification'
          type='classification'
          valueField='id'
          searchParams={{
            alternate_class,
            excluded_classifications,
            included_classifications,      
          }}
          component={ multiple ? renderSearchMultipleDropdown : renderSearchDropDown }
          onPostChange={onPostChange}
          preload={preload}
        />
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(ClassificationDropdown);
